import React from 'react';
import propTypes from 'prop-types';

const UserHeadline = props => {


    const {headlineClass, headline} = props;

    return (
        <p className={headlineClass}>{headline}</p>
    )

};

UserHeadline.propTypes = {
    headlineClass: propTypes.string,
    headline: propTypes.string
};

export default UserHeadline;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/UserHeadline.js